import Vue from 'vue';
import Router from 'vue-router';
import { Screen } from 'quasar';
import Routes from './routes/routes';

Vue.use(Router);
const router = new Router({
  base: '/',
  mode: 'history',
  routes: Routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;

router.beforeEach((to, from, next) => {
  const urlsPublicas = ['/login', '/reject_notice_of_privacy'];
  const urlsMobile = ['/checklist', '/report', '/reception'];
  // const autenticacionNoRequerida = !urlsPublicas.includes(to.path) && !to.path.includes("/auth");
  const isMobile = urlsMobile.includes(to.path);
  const logueado = router.app.$session.get('orderId');
  // const isProd = process.env.NODE_ENV == "production";

  /*
  Comentamos estas validaciones ya que anteriormente
  IDKIT guardaba la sesión y solo teniamos que eliminar la sesión de
  ADS para que nos volviera a inyectar los datos,
  ahora ADS es el que debe de guardar esa sesión y ahora debemos
  permitirle pasar a la ruta de order aún cuando
  exista la sesión ya que dentro del mounted de esta ruta elimina
  la sesión de ADS para sobreescribirla en dado caso que cambien de superOrderId
  if (to.path.includes("/order") && router.app.$session.exists()) {
    let newSuperOrderId = to.query.orderId;
    let oldSuperOrderId = router.app.$session.get("orderIdDMS");
    if (newSuperOrderId !== oldSuperOrderId
      && oldSuperOrderId !== undefined && newSuperOrderId !== undefined) {
      router.app.$session.destroy();
      return next({ path: "/order", query: { orderId: to.query.orderId } });
    }
  }
*/

  // if (autenticacionNoRequerida && logueado) {
  //   next({ path: "/" });
  // }

  if (Screen.gt.sm && isMobile) {
    next({ path: '/home' });
  }

  if (urlsPublicas.indexOf(to.path) >= 0 && logueado) {
    next({ path: '/home' });
  }

  if (typeof Vue.prototype.ultimaNotificacion === 'function') {
    Vue.prototype.ultimaNotificacion();
  }

  next();
});
